import { DefaultRequest } from 'scripts/api';

Greenmile.Survey = Greenmile.Survey || {};

Greenmile.Survey.ReportTemplate = function () {

    this.surveyId;

    this.setSurveyId = function (surveyId) {
        this.surveyId = surveyId;
    };

    this.projection = {
      filters: [
        'id', 'reportTemplates.*'
      ],
      firstResult: 0,
      maxResults: 51
    };

    this.startGenerate = function () {

        Greenmile.Survey.Modal = Greenmile.Survey.Modal || {};
        Greenmile.Survey.Modal.UploadModal = new Greenmile.Survey.UploadModal();
        Greenmile.Survey.Modal.UploadModal.setSurveyId(this.surveyId);

        if (this.reportTemplates.length) {
            Greenmile.Survey.Modal.UploadModal.showGenerateWindow();
        } else {
            Greenmile.Survey.Modal.UploadModal.showModalForm();
        }

    };

    this.fetchTemplates = function () {

        const request = new DefaultRequest({
            method: "post",
            url: '/Survey/restrictions?criteria=' + JSON.stringify(this.projection),
            data: { criteriaChain: [{ and: [{ attr: "id", eq: this.surveyId }] }] },
            success: function (data) {
                var collection = new App.Collections.ReportTemplates(data);
                var model = collection.first();
                this.reportTemplates = (model && model.attributes.reportTemplates) ? model.attributes.reportTemplates : [];
                this.startGenerate();

            }.bind(this),
        });
        request.send();
    }

};
